import {apiback} from '../../config';
import buildUrl from 'utils/buildGetURLWithParams';

export default {
    getWidgets: function() {
        const {where_by, search_by} = this.state,
            pageParams = {where_by, search_by};
        const url = buildUrl(apiback('API_PAGES'), pageParams);

        fetch(url)
            .then(res => res.json())
            .then(({data}) => {
                this.setState({
                    widgets: data[0] ? data[0].pageWidgets : [],
                    loader: false,
                    ui: this.uiStates.INTERACTIVE
                });
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    },
    getWidget: function(code) {
        return this.state.widgets.find(widget => widget.code === code) || {};
    },
    getWidgets_2: function() {
        const where_by = this.state.where_by_2,
            search_by = this.state.search_by_2,
            pageParams = {where_by, search_by};
        const url = buildUrl(apiback('API_PAGES'), pageParams);

        fetch(url)
            .then(res => res.json())
            .then(({data}) => {
                this.setState({
                    widgets_2: data[0] ? data[0].pageWidgets : []
                });
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    },
    getWidget_2: function(code) {
        return this.state.widgets_2.find(widget => widget.code === code) || {};
    },

    getWidgets_3: function() {
        const where_by = this.state.where_by_3,
            search_by = this.state.search_by_3,
            pageParams = {where_by, search_by};
        const url = buildUrl(apiback('API_PAGES'), pageParams);

        fetch(url)
            .then(res => res.json())
            .then(({data}) => {
                this.setState({
                    widgets_3: data[0] ? data[0].pageWidgets : []
                });
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    },
    getWidget_3: function(code) {
        return this.state.widgets_3.find(widget => widget.code === code) || {};
    }
};
